import { useDispatch, useSelector } from "react-redux";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";
import { Radio } from "@rmwc/radio";
import { extraItemsAction } from "../../../action";

const CrossBracing = ({ leanType, lean }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();

	const isGableLean = params.leanStyle[leanType] === "gable";

	const sideCrossBracing = lean.pricing_data && lean.pricing_data.side_cross_bracing;
	const endCrossBracing = lean.pricing_data && lean.pricing_data.end_cross_bracing;

	let isEndPRiceDisabled =
		(leanType == "left" && params.added_building_bracing.p_e_c_b_l === true) ||
		(leanType == "right" && params.added_building_bracing.p_e_c_b_r === true) ||
		(leanType == "front" && params.added_building_bracing.p_e_c_b_f === true) ||
		(leanType == "back" && params.added_building_bracing.p_e_c_b_b === true)
			? "false"
			: "true";

	let isSidePriceDisabled =
		(leanType == "left" && params.added_building_bracing.p_s_c_b_l === true) ||
		(leanType == "right" && params.added_building_bracing.p_s_c_b_r === true) ||
		(leanType == "front" && params.added_building_bracing.p_s_c_b_f === true) ||
		(leanType == "back" && params.added_building_bracing.p_s_c_b_b === true)
			? "false"
			: "true";

	let elementPrice =
		const_var.lNTBuildingData["updatePriceDataElements"] && const_var.lNTBuildingData["updatePriceDataElements"][leanType] != undefined && const_var.lNTBuildingData["updatePriceDataElements"][leanType];

	const returnBracingPrice = (data, isFor) => {
		if (isFor == "side") {
			let BracingObject = Object.keys(data).find((obj) => data[obj] && data[obj].other_item_name && data[obj].other_item_name == "Side Cross Bracing");
			return (
				<>
					{BracingObject && data[BracingObject]?.item_price ? (
						<div className="price-box-type-2">
							<CurrencyFormat value={data[BracingObject].item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
						</div>
					) : null}
				</>
			);
		}
		if (isFor == "end") {
			let BracingObject = Object.keys(data).find((obj) => data[obj] && data[obj].other_item_name && data[obj].other_item_name == "End Cross Bracing");
			return (
				<>
					{BracingObject && data[BracingObject]?.item_price ? (
						<div className="price-box-type-2">
							<CurrencyFormat value={data[BracingObject].item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
						</div>
					) : null}
				</>
			);
		}
	};

	return (
		<div className="row">
			{((sideCrossBracing && sideCrossBracing.length > 0) || (endCrossBracing && endCrossBracing.length > 0)) && <div className="col-12 control-label">Types of Bracing : </div>}
			{sideCrossBracing && sideCrossBracing.length > 0 && (
				<div className="col-6">
					<div className="form-group">
						<label className="control-label">Side</label>
						{sideCrossBracing.map((option, index) => {
							return (
								<div className="row">
									<div className={"col-12" + (option.is_default == "included" && sideCrossBracing.length == 1 ? " disabled" : "")}>
										<div className="radio-group">
											<Radio
												key={index}
												label={option.sheet_label}
												value={option.sheet_name}
												name="side-bracing-type"
												checked={option.sheet_name === const_var.selectedBracingForAddedBuilding[leanType + "_lean_side"]}
												onChange={(e) => dispatch(extraItemsAction(e.target.value, leanType + "-scbracing"))}
											/>
										</div>
										{option.sheet_name != "none" && option.sheet_name === const_var.selectedBracingForAddedBuilding[leanType + "_lean_side"] && (
											<>
												{const_var.post_data.building !== undefined && const_var.loginSession == true ? (
													<div className="price-box">
														<EditPriceItem
															is_disabled={isSidePriceDisabled}
															/* jsonIsLeanto={leanType} */ jsonObj={"extraitems"}
															jsonObjValue={
																leanType == "left"
																	? params.added_building_bracing.p_s_c_b_l
																	: leanType == "right"
																		? params.added_building_bracing.p_s_c_b_r
																		: leanType == "front"
																			? params.added_building_bracing.p_s_c_b_f
																			: params.added_building_bracing.p_s_c_b_b
															}
															jsonObjKey="Side Cross Bracing"
														/>
													</div>
												) : (
													<>{const_var.hide_price_calculation != 1 && const_var.loginSession == false && returnBracingPrice(elementPrice, "side")}</>
												)}
											</>
										)}
									</div>
								</div>
							);
						})}
					</div>
				</div>
			)}
			{endCrossBracing && endCrossBracing.length > 0 && (
				<div className="col-6">
					<div className="form-group">
						<label className="control-label">End</label>
						{endCrossBracing.map((option, index) => {
							return (
								<div className="row">
									<div className={"col-12" + (option.is_default == "included" && endCrossBracing.length == 1 ? " disabled" : "")}>
										<div className="radio-group">
											<Radio
												key={index}
												label={option.sheet_label}
												value={option.sheet_name}
												name="end-bracing-type"
												checked={option.sheet_name === const_var.selectedBracingForAddedBuilding[leanType + "_lean_end"]}
												onChange={(e) => dispatch(extraItemsAction(e.target.value, leanType + "-ecbracing"))}
											/>
										</div>
										{option.sheet_name != "none" && option.sheet_name === const_var.selectedBracingForAddedBuilding[leanType + "_lean_end"] && (
											<>
												{const_var.post_data.building !== undefined && const_var.loginSession == true ? (
													<div className="price-box">
														<EditPriceItem
															is_disabled={isEndPRiceDisabled}
															/* jsonIsLeanto={leanType} */ jsonObj={"extraitems"}
															jsonObjValue={
																leanType == "left"
																	? params.added_building_bracing.p_e_c_b_l
																	: leanType == "right"
																		? params.added_building_bracing.p_e_c_b_r
																		: leanType == "front"
																			? params.added_building_bracing.p_e_c_b_f
																			: params.added_building_bracing.p_e_c_b_b
															}
															jsonObjKey="End Cross Bracing"
														/>
													</div>
												) : (
													<>{const_var.hide_price_calculation != 1 && const_var.loginSession == false && returnBracingPrice(elementPrice, "end")}</>
												)}
											</>
										)}
									</div>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
};

export default CrossBracing;
